import CryptoJS from 'crypto-js'

const keyValue = 'K6omUpNdGZhEN4zdM7vU9JF9KYMrtHBU' // your key value (eg: key)
const ivKey = 'E6E3EE18AACF621D43E8861DBB36E' // your iv key value (eg: a2xhcgAAAAAAAAAA)

export function encryptData(data) {
  if (data) {
    const key = CryptoJS.PBKDF2(keyValue, 'salt', {
      keySize: 256 / 32,
      iterations: 100,
    })
    const iv = CryptoJS.enc.Utf8.parse(ivKey) // Convert string to WordArray
    const encrypted = CryptoJS.AES.encrypt(data, key, {
      iv,
      mode: CryptoJS.mode.CBC,
    })
    return encrypted.ciphertext.toString(CryptoJS.enc.Hex)
  }

  return ''
}

export function decryptData(data) {
  if (data) {
    const key = CryptoJS.PBKDF2(keyValue, 'salt', {
      keySize: 256 / 32,
      iterations: 100,
    })
    const iv = CryptoJS.enc.Utf8.parse(ivKey)
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: CryptoJS.enc.Hex.parse(data) },
      key,
      { iv, mode: CryptoJS.mode.CBC },
    )
    return decrypted.toString(CryptoJS.enc.Utf8)
  }

  return ''
}

export function hashData(data) {
  return data ? CryptoJS.MD5(data).toString(CryptoJS.enc.Hex) : ''
}
